var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerificationQuiz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 42C35.8284 42 36.5 41.3284 36.5 40.5C36.5 39.6716 35.8284 39 35 39C34.1716 39 33.5 39.6716 33.5 40.5C33.5 41.3284 34.1716 42 35 42Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5 25.5C41.5 29.13 39.5062 30.81 36.0862 31.5V36C36.0862 36.825 35.825 37.5 35 37.5C34.175 37.5 33.5 36.825 33.5 36V31C33.5 30 34.175 29.3346 35 29.3346C37.475 29.3346 39.5 27.975 39.5 25.5C39.5 23.025 37.475 21 35 21C32.525 21 30.5 23.025 30.5 25.5C30.5 26.325 30.325 27 29.5 27C28.675 27 28.5 26.325 28.5 25.5C28.5 21.36 30.86 19 35 19C39.14 19 41.5 21.36 41.5 25.5ZM18.5 16H14C13.1705 16 12.5 15.828 12.5 15C12.5 14.172 13.1705 14 14 14H18.5C19.3295 14 20 14.172 20 15C20 15.828 19.3295 16 18.5 16ZM24.5 21C24.5 21.825 23.825 22 23 22H14C13.175 22 12.5 21.825 12.5 21C12.5 20.175 13.175 20 14 20H23C23.825 20 24.5 20.175 24.5 21ZM24.5 27C24.5 27.825 23.825 28 23 28H14C13.175 28 12.5 27.825 12.5 27C12.5 26.175 13.175 26 14 26H23C23.825 26 24.5 26.175 24.5 27Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 9V13.44C33.5 14.265 33.325 15 32.5 15C31.675 15 31.5 14.265 31.5 13.44V10C31.5 9.58 31.5 8 30.5 8H20.5H9.5C8.765 8 8.5 9 8.5 11V25V37C8.5 38 8.5 40 9.5 40H19.5H29C29.825 40 30.5 40.175 30.5 41C30.5 41.825 29.825 42 29 42H9.5C7.85 42 6.5 40.65 6.5 39V9C6.5 7.35 7.85 6 9.5 6H30.5C32.15 6 33.5 7.35 33.5 9Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 33C24.5 33.825 23.825 34 23 34H14C13.175 34 12.5 33.825 12.5 33C12.5 32.175 13.175 32 14 32H23C23.825 32 24.5 32.175 24.5 33Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerificationQuiz);
export default __webpack_public_path__ + "static/media/verification_quiz.ab9353530c774fbebe1bda1cf03186d2.svg";
export { ForwardRef as ReactComponent };